import type { ChipVariant } from '@/components/ui'

// Mirrors ItemState in app/models/dev_tracker.py — spec §5 state machine.
// Kept out of StateBadge.tsx (react-refresh/only-export-components — a
// file exporting a component can't also export plain values/functions
// without breaking Fast Refresh for that component).
export const STATE_META: Record<string, { label: string; variant: ChipVariant }> = {
  backlog: { label: 'Backlog', variant: 'neutral' },
  specced: { label: 'Specced', variant: 'neutral' },
  in_progress: { label: 'In progress', variant: 'info' },
  needs_chris: { label: 'Needs Chris', variant: 'warning' },
  staging: { label: 'Staging', variant: 'info' },
  deployed: { label: 'Deployed', variant: 'accent' },
  verified: { label: 'Verified', variant: 'success' },
  deferred: { label: 'Deferred', variant: 'warning' },
  cancelled: { label: 'Cancelled', variant: 'danger' },
}

export function stateLabel(state: string): string {
  return STATE_META[state]?.label ?? state
}

/** Ordered for the "move to" picker — mirrors the spec §5 state machine's
 * rough left-to-right flow, terminals last. */
export const ALL_ITEM_STATES = [
  'backlog', 'specced', 'in_progress', 'needs_chris', 'staging',
  'deployed', 'verified', 'deferred', 'cancelled',
] as const
